import api from "@/utils/api";
import { API_ENDPOINTS, ApiResponse } from "@/constants/api";
import logger from "@/utils/logger";

/**
 * 검색 로그를 남기는 API 함수
 * @param alcoholAltKey 클릭한 상품의 고유 ID
 * @param searchTerm 검색어
 */
export const logSearchClick = async (alcoholAltKey: string, searchTerm: string): Promise<void> => {
    try {
        await api.post(API_ENDPOINTS.ALCOHOL_SEARCH_LOG, {
            alcoholAltKey,
            searchTerm
        });
        logger.log("[Search Log] 검색 로그 기록 성공:", { alcoholAltKey, searchTerm });
    } catch (error) {
        logger.error("[Search Log] 검색 로그 기록 실패:", error);
        // 실패해도 사용자 경험에 영향을 주지 않도록 에러는 무시
    }
};

/**
 * 상품 상세 정보 조회 API
 * @param altKey 상품 고유 ID
 */
export const getAlcoholDetail = async (altKey: string) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.ALCOHOLS}/${altKey}`);
        return response.data;
    } catch (error) {
        logger.error("상품 상세 정보 조회 실패:", error);
        throw error;
    }
};

/**
 * 상품 검색 API
 * @param searchTerm 검색어
 */
export const searchAlcohols = async (searchTerm: string) => {
    try {
        const response = await api.get<ApiResponse<any[]>>(
            `${API_ENDPOINTS.ALCOHOL_SEARCH}?name=${encodeURIComponent(searchTerm)}`
        );
        return response.data;
    } catch (error) {
        logger.error("상품 검색 실패:", error);
        throw error;
    }
};
